// @ts-nocheck
import { billingAddressFormSchema } from './billing.schema'; // import new schema
import * as Yup from 'yup';

export const paymentSchema = Yup.object().shape({
    billing: billingAddressFormSchema, // use billing schema (no FedEx PO Box check)
    confirmationToken: Yup.string(),
});

export type PaymentForm = Yup.InferType<typeof paymentSchema>;
